<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Colors</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.backgroundContentColor"
                  name="backgroundContentColor"
                  label="Background Content"
                  default-color="#F6F8FF"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.borderColor"
                  name="borderColor"
                  label="Border Color"
                  default-color="#E5E7EB"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Image</label>
          <div class="group-item">
            <v-select
              v-model="fields.image.position"
              label="Position"
              :items="positionOptions"
              item-text="text"
              item-value="value"
            />
            <UploadImage
              @callback="handleUploadImage"
              :image="{ imageSrc: fields.image.src }"
              :height="`200`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveImage"
            />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Content</label>
          <div class="group-item">
            <ckeditor :editor="editor" :config="editorConfig" v-model="fields.content" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Quotes</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.quotes.start.show" label="Show" hide-details />
                <div>
                  <UploadImage
                    @callback="handleUploadQuoteStart"
                    :image="{ imageSrc: fields.quotes.start.src }"
                    :height="`120`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveQuoteStart"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.quotes.end.show" label="Show" hide-details />
                <div>
                  <UploadImage
                    @callback="handleUploadQuoteEnd"
                    :image="{ imageSrc: fields.quotes.end.src }"
                    :height="`120`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveQuoteEnd"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Author</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.author.name" label="Name" hide-details />
              </v-col>
              <v-col cols="12" md="6" class="d-flex align-center" style="gap: 10px">
                <v-checkbox v-model="fields.author.signature.show" label="Show signature" hide-details />
              </v-col>
            </v-row>
            <div v-if="fields.author.signature.show" class="mt-2">
              <UploadImage
                @callback="handleUploadSignature"
                :image="{ imageSrc: fields.author.signature.src }"
                :height="`120`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveSignature"
              />
            </div>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import ColorPicker from './common/color-picker.vue';

export default {
  name: 'fastvaluedeal-reviewer-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: [
        { text: 'Left', value: 'left' },
        { text: 'Right', value: 'right' },
      ],
      fields: {
        title: 'Fastvaluedeal Reviewer',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        image: {
          src: '',
          position: 'left',
        },
        content: '',
        quotes: {
          start: {
            show: true,
            src: '',
          },
          end: {
            show: true,
            src: '',
          },
        },
        author: {
          name: 'Connor Smith',
          signature: {
            show: true,
            src: '',
          },
        },
        backgroundContentColor: '#F6F8FF',
        borderColor: '#E5E7EB',
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        image: { ...this.fields.image, ...(extract.image || {}) },
        quotes: {
          ...this.fields.quotes,
          ...(extract.quotes || {}),
          start: { ...this.fields.quotes.start, ...((extract.quotes || {}).start || {}) },
          end: { ...this.fields.quotes.end, ...((extract.quotes || {}).end || {}) },
        },
        author: {
          ...this.fields.author,
          ...(extract.author || {}),
          signature: {
            ...this.fields.author.signature,
            ...((extract.author || {}).signature || {}),
          },
        },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFastvaluedealReviewer(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields.image.src = (obj && obj.imageSrc) || '';
    },
    handleRemoveImage() {
      this.fields.image.src = '';
    },
    handleUploadSignature(obj) {
      this.fields.author.signature.src = (obj && obj.imageSrc) || '';
    },
    handleRemoveSignature() {
      this.fields.author.signature.src = '';
    },
    handleUploadQuoteStart(obj) {
      this.fields.quotes.start.src = (obj && obj.imageSrc) || '';
    },
    handleRemoveQuoteStart() {
      this.fields.quotes.start.src = '';
    },
    handleUploadQuoteEnd(obj) {
      this.fields.quotes.end.src = (obj && obj.imageSrc) || '';
    },
    handleRemoveQuoteEnd() {
      this.fields.quotes.end.src = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
::v-deep .ck-editor__editable_inline {
  min-height: 120px !important;
}
</style>
